import * as React from 'react';
import Component from '../Component';

export default class Date extends Component {

    render() {
        return (<span className="d-inline-block">{this.props.date.format(this.getDateFormat())}</span>);
    }
}